// @givmo/app-admin — admin role constants + helpers (07-1.5b).
//
// The canonical role enum is `CompanyAdminMembershipType = 'Owner' | 'Member'` (the wire strings, also
// what `AdminOut.admin_company_role` carries and what the role PUT requires). The invite body types
// `role` as a loose string, but we always send one of these two canonical values.

import type { CompanyAdminMembershipType } from '@givmo/api-client';

export const ROLE_OWNER: CompanyAdminMembershipType = 'Owner';
export const ROLE_MEMBER: CompanyAdminMembershipType = 'Member';

export const MEMBER_DESC =
  'Able to conduct donation operations, but does not have permission to modify Match Policy, ' +
  'privacy settings, or admin settings.';

/**
 * Coerce a possibly-null/unknown role string into a canonical `CompanyAdminMembershipType`. Anything
 * that isn't exactly 'Member' falls back to 'Owner' — matching the Flutter popup's permissive default
 * (`AdminRole.fromString(...) ?? AdminRole.owner`).
 */
export function normalizeRole(role: string | null | undefined): CompanyAdminMembershipType {
  return role === ROLE_MEMBER ? ROLE_MEMBER : ROLE_OWNER;
}
